// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"408":"d1d261a4","762":"5eb8e888"}[chunkId] + ".chunk.css";
};